import * as Yup from "yup";

export const customFieldSchema = Yup.object().shape({
  field: Yup.string().required("Field ID is required"),
  fieldLabel: Yup.string().required("Field label is required"),
  type: Yup.string().required("Field type is required")
});
